import React from 'react';
import { IconID } from '../../icon';
import { BaseSegmentControl } from '../base-control';
import styles from './font-formatter.module.scss';
import { FontItemID } from './font-formatter-id';
import { FontFormatterItem } from './font-formatter-item';
const IdValueToKeyMap = {
    [FontItemID.BOLD]: 'BOLD',
    [FontItemID.ITALIC]: 'ITALIC',
    [FontItemID.UNDERLINE]: 'UNDERLINE',
    [FontItemID.STRIKE_THROUGH]: 'STRIKE_THROUGH',
    [FontItemID.WRAP]: 'WRAP',
};
const getFontFormatterChildItem = (id, disabledItems, itemClassNames, preserveIconColor) => (React.createElement(FontFormatterItem, { icon: IconID[IdValueToKeyMap[id]], disabled: disabledItems.includes(id), key: id, classNames: itemClassNames, preserveIconColor: preserveIconColor }));
export const FontFormatter = ({ visibleItems = [
    FontItemID.BOLD,
    FontItemID.ITALIC,
    FontItemID.UNDERLINE,
    FontItemID.STRIKE_THROUGH,
], selectedItems = [], disabledItems = [], classNames, itemClassNames, preserveIconColor = false, ...restProps }) => {
    var _a, _b, _c;
    const { segmentedControl, disabled, selectedHighlight } = styles;
    const selectedItemsAsIndexes = selectedItems.map((id) => visibleItems.indexOf(id));
    return (React.createElement(BaseSegmentControl, { selectedIndex: selectedItemsAsIndexes, ...restProps, classNames: {
            segmentedControl: (_a = classNames === null || classNames === void 0 ? void 0 : classNames.segmentedControl) !== null && _a !== void 0 ? _a : segmentedControl,
            disabled: (_b = classNames === null || classNames === void 0 ? void 0 : classNames.disabled) !== null && _b !== void 0 ? _b : disabled,
            selectedHighlight: (_c = classNames === null || classNames === void 0 ? void 0 : classNames.selectedHighlight) !== null && _c !== void 0 ? _c : selectedHighlight,
        }, widthAdjust: 0, type: "FormFormatterControl" }, visibleItems.map((id) => getFontFormatterChildItem(id, disabledItems, itemClassNames, preserveIconColor))));
};
//# sourceMappingURL=font-formatter.js.map